export default "__VITE_ASSET__Cxz_HC1w__"